import { render } from "./MapWallet.vue?vue&type=template&id=887c7b74"
import script from "./MapWallet.vue?vue&type=script&lang=js"
export * from "./MapWallet.vue?vue&type=script&lang=js"

import "vue-multiselect/dist/vue-multiselect.css?vue&type=style&index=0&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__